
const newModel = () => {
    return {
        tuyenDenduongId: null,
        ten: null,
        loaiTuyenduongId: null,
        tenLoaiTuyenduong: null,
        phuongXaId: null,
        tenPhuongXa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}


const newFEModel = () => {
    return {
        tuyenDenduongId: null,
        ten: null,
        loaiTuyenduongId: null,
        phuongXaId: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}

const fromJson = (item) => {
    return {
        tuyenDenduongId: item.tuyenDenduongId,
        ten: item.ten,
        loaiTuyenduongId: item.loaiTuyenduongId,
        tenLoaiTuyenduong: item.tenLoaiTuyenduong,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted:item.userDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        tuyenDenduongId: item.tuyenDenduongId,
        ten: item.ten,
        loaiTuyenduongId: item.loaiTuyenduongId,
        phuongXaId: item.phuongXaId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted:item.userDeleted,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        loaiTuyenduongId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        loaiTuyenduongId: item.loaiTuyenduongId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        tuyenDenduongId: null,
        ten: null,
        loaiTuyenduongId: null,
        phuongXaId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
} 

export const tuyenDenDuongModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}
